module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-card', [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v("登入")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "mt-5 input-group",
    attrs: {
      "label": "帳號",
      "required": ""
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group",
    attrs: {
      "label": "請輸入密碼",
      "hint": "",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "新北市親師生平台登入"
    },
    model: {
      value: (_vm.checkbox),
      callback: function($$v) {
        _vm.checkbox = $$v
      },
      expression: "checkbox"
    }
  }), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "fluid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs6": ""
    }
  }, [_c('small', [_vm._v("*必填欄位")])]), _vm._v(" "), _c('v-col', {
    staticClass: "text-sm-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "light": "",
      "flat": "",
      "router": "",
      "href": "/forgot_password"
    }
  }, [_vm._v("忘記密碼？")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-row', {
    staticClass: "mt-4",
    attrs: {
      "actions": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "primary": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.validation()
      }
    }
  }, [_vm._v("登入")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de263a48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 786
// module chunks = 1